<div id="caseDataHeader">
  <h3 class="headline-small">{{ titleKey() | translate }}</h3>
  <div id="caseDataHeaderActions">
    @if (showAllToggleVisible()) {
      <button mat-icon-button id="showAllButton" (click)="toggleShowAll()" [attr.aria-pressed]="showAll()"
              [attr.aria-label]="(showAll() ? 'caseData.showConfigured' : 'caseData.showAll') | translate"
              [title]="(showAll() ? 'caseData.showConfigured' : 'caseData.showAll') | translate">
        <mat-icon class="material-symbols-outlined">{{ showAll() ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    }
    <button mat-icon-button (click)="downloadCustomData()" [disabled]="isEmpty()"
            [attr.aria-label]="'caseData.download' | translate" [title]="'caseData.download' | translate">
      <mat-icon class="material-symbols-outlined">download</mat-icon>
    </button>
    <button mat-icon-button (click)="close()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<div id="caseDataSearch">
  <mat-icon class="material-symbols-outlined">search</mat-icon>
  <input [ngModel]="query()" (ngModelChange)="query.set($event)"
         [placeholder]="'caseData.searchPlaceholder' | translate"/>
  @if (query().length > 0) {
    <button mat-icon-button id="clearSearchButton" (click)="clearSearch()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  }
</div>

<div id="caseDataSeparator"></div>

<div id="caseDataScroller">
  @if (loading()) {
    @for (i of [1, 2, 3]; track i) {
      <div class="caseDataRow skeleton">
        <div class="skeletonLine skeletonPulse" style="width: 40%"></div>
        <div class="skeletonLine skeletonPulse" style="width: 70%; margin-top: 6px"></div>
      </div>
    }
  } @else if (isEmpty()) {
    <div class="caseDataEmptyState">
      <mat-icon class="material-symbols-outlined">data_object</mat-icon>
      <p class="body-medium">{{ 'caseData.emptyState' | translate }}</p>
    </div>
  } @else if (noResults()) {
    <div class="caseDataEmptyState">
      <mat-icon class="material-symbols-outlined">search_off</mat-icon>
      <p class="body-medium">{{ 'caseData.noResults' | translate:{query: query()} }}</p>
    </div>
  } @else if (filteredEmpty()) {
    <div class="caseDataEmptyState">
      <mat-icon class="material-symbols-outlined">visibility_off</mat-icon>
      <p class="body-medium">{{ 'caseData.filteredEmptyState' | translate }}</p>
    </div>
  } @else {
    @for (group of groups(); track group.path) {
      <div class="groupRail" [class.nested]="group.depth > 0"
           [style.paddingLeft.px]="group.depth * 14"
           [style.backgroundSize]="group.depth * 14 + 'px 100%'">
        <div class="groupCard" [class.root]="group.depth === 0">
          <button class="groupHeader" (click)="toggleGroup(group.path)">
            <mat-icon class="material-symbols-outlined">{{ group.open ? 'expand_more' : 'chevron_right' }}</mat-icon>
            <span class="groupPath">{{ group.displayPath }}</span>
            <span class="groupCount">{{ group.fields.length }}</span>
          </button>
          @if (group.open) {
            <div class="groupFields">
              @for (field of group.fields; track field.path) {
                <div class="groupField">
                  <div class="fieldLabel">{{ field.label }}</div>
                  <div class="fieldValue" [class.empty]="field.empty">{{ field.value }}</div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  }
</div>
